import(/* webpackMode: "eager" */ "/vercel/path0/app/blog/layout.tsx");
